// extracted by mini-css-extract-plugin
module.exports = {"top-wrapper":"FormHeading_top-wrapper__g63JM","top-wrapper__heading":"FormHeading_top-wrapper__heading__13vuh","top-wrapper__desc":"FormHeading_top-wrapper__desc__R1YVc"};